import { useContext, useEffect, useState } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import AdminContext from "../../../Helper/admin/index.jsx";
import useFetchBugsAndActivities from "../../../hook/useFetchBugsAndActivities.js";
import useFetchUsersAndCourses from "../../../hook/useFetchUsersAndCourses.js";
import AdminActivities from "./AdminActivities/AdminActivities.jsx";
import AppoimentCard from "./Appoiment/AppoimentCard.jsx";
import BugsReported from "./BugsReported/BugsReported.jsx";
import CountryCard from "./Country/Country.jsx";
import Greetingcard from "./GreetingCard";
import MonthlyAttendance from "./MonthlyAttendance/MonthlyAttendance.jsx";
import Ravanuechart from "./RevanueChart.jsx/index.jsx";
import StudentActivities from "./StudentActivities/StudentActivities.jsx";
import TotalGrowthCard from "./TotalGrowth/TotalGrowthCard.jsx";
import TotalUserCard from "./TotalUser/TotalUserCard.jsx";
import QuizResults from "./QuizResults/QuizResults.jsx";

const Default = () => {
  const { user } = useContext(AdminContext);
  const [loadUsersAndCourses, setLoadUsersAndCourses] = useState(false);
  const {
    students,
    courses,
    attendance,
    loading: usersAndCoursesLoading
  } = useFetchUsersAndCourses(loadUsersAndCourses);

  const {
    bugsAndActivities: {
      bugs,
      adminActivities,
      studentActivities
    },
    loading: bugsAndActivitiesLoading
  } = useFetchBugsAndActivities();

  useEffect(() => {
    if (!bugsAndActivitiesLoading) {
      setLoadUsersAndCourses(true);
    }

    return () => {
      setLoadUsersAndCourses(false);
    };
  }, [bugsAndActivitiesLoading, usersAndCoursesLoading]);

  return (
    <>
      <Breadcrumbs mainTitle="Dashboard" parent="Dashboard" title="Dashboard" />
      <Container fluid={true} className="dashboard-default">
        <Row>
          <Greetingcard user={user} />
          <Ravanuechart />
          <TotalUserCard allStudents={students} loading={usersAndCoursesLoading} />
          <MonthlyAttendance allAttendance={attendance} allStudents={students} allCourses={courses} loading={usersAndCoursesLoading} />
          <QuizResults allStudents={students} allCourses={courses} loading={usersAndCoursesLoading} />
          {/* <AppoimentCard /> */}
          <TotalGrowthCard />
          <StudentActivities studentActivities={studentActivities} loading={bugsAndActivitiesLoading} />
          <AdminActivities adminActivities={adminActivities} loading={bugsAndActivitiesLoading} />
          <BugsReported bugs={bugs} loading={bugsAndActivitiesLoading} />
          <CountryCard />
        </Row>
      </Container>
    </>
  );
};

export default Default;
